import { FC } from "react";
import { MDXEditorView } from "shared/components/MDXEditor";
import { ApplicantType, VerificationNames } from "shared/types";
import { useTemplateContext } from "../provider";

export const DisclosureSlice: FC<{
  original: string;
  verificationName:
    | VerificationNames.TermsAndConditions
    | VerificationNames.SubmissionDisclosure;
}> = ({ original, verificationName }) => {
  const { readOnly, template, setTemplate } = useTemplateContext();

  const value =
    template?.verification_schemas[ApplicantType.Applicant][verificationName]
      ?.additional_text || "";

  const onChange = (newValue: string) => {
    if (!template) return;
    const updatedTemplate = { ...template };

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!updatedTemplate.verification_schemas) return;
    if (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      !updatedTemplate.verification_schemas[ApplicantType.Applicant][
        verificationName
      ]
    ) {
      updatedTemplate.verification_schemas[ApplicantType.Applicant][
        verificationName
      ] = {
        additional_text: ""
      };
      updatedTemplate.verification_schemas[ApplicantType.CoSigner][
        verificationName
      ] = {
        additional_text: ""
      };
    }

    // @ts-ignore -- weird TS error
    updatedTemplate.verification_schemas[ApplicantType.Applicant][
      verificationName
    ].additional_text = newValue;

    if (
      updatedTemplate.verification_schemas[ApplicantType.CoSigner][
        verificationName
      ]
    )
      // @ts-ignore -- weird TS error
      updatedTemplate.verification_schemas[ApplicantType.CoSigner][
        verificationName
      ].additional_text = newValue;

    setTemplate(updatedTemplate);
  };

  return (
    <MDXEditorView
      readOnly={Boolean(readOnly)}
      original={original}
      value={value}
      onChange={onChange}
    />
  );
};
